<template>
    <div>
        <div class="contents">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="breadcrumb-main user-member justify-content-sm-between ">
                            <div class=" d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
                                <div
                                    class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
                                    <h4 class="text-capitalize fw-500 breadcrumb-title">Profile</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div v-if="!isLoading"
                            class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                            <label for="">Email</label>
                            <input type="email" v-model="user.email" class="form-control" required>
                            <br>
                            <label for="">Name</label>
                            <input type="text" v-model="user.name" class="form-control" required>
                            <br>
                            <label for="">No Telp</label>
                            <input type="text" v-model="user.phone" class="form-control" required>
                            <br>
                            <label for="">Timezone</label>
                            <select class="form-control" v-model="user.timezone">
                                <option value="-12">GMT -12</option>
                                <option value="-11">GMT -11</option>
                                <option value="-10">GMT -10</option>
                                <option value="-9">GMT -9</option>
                                <option value="-8">GMT -8</option>
                                <option value="-7">GMT -7</option>
                                <option value="-6">GMT -6</option>
                                <option value="-5">GMT -5</option>
                                <option value="-4">GMT -4</option>
                                <option value="-3">GMT -3</option>
                                <option value="-2">GMT -2</option>
                                <option value="-1">GMT -1</option>
                                <option value="0">GMT 0</option>
                                <option value="1">GMT +1</option>
                                <option value="2">GMT +2</option>
                                <option value="3">GMT +3</option>
                                <option value="4">GMT +4</option>
                                <option value="5">GMT +5</option>
                                <option value="6">GMT +6</option>
                                <option value="7">GMT +7</option>
                                <option value="8">GMT +8</option>
                                <option value="9">GMT +9</option>
                                <option value="10">GMT +10</option>
                                <option value="11">GMT +11</option>
                                <option value="12">GMT +12</option>
                            </select>
                            <br>
                            <label for="">Account API Key</label>
                            <input type="text" class="form-control" v-model="user.api_key" readonly>
                            <br>
                            <label for="">Password Baru (Kosongkan Jika Tidak Ingin Mengganti Password)</label>
                            <input type="text" class="form-control" v-model="user.password">
                            <br>
                            <button v-on:click="updateUser" class="btn btn-outline-success btn-block">Simpan</button>
                            <br>
                            <button v-on:click="resetApiKey" class="btn btn-outline-warning btn-block">Regenerate Account API Key</button>

                        </div>
                        <div v-else class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                            <center>
                                <div class="spinner-border spinner" role="status"></div>
                            </center>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        data() {
            return {
                isLoading: true,
                user: {}
            };
        },
        mounted() {
            this.loadData()
        },
        methods: {
            async loadData() {
                try {
                    let detail = await this.$store.dispatch("user_detail")
                    this.user = detail.data.data.user
                    this.user.reff_url = process.env.VUE_APP_FRONTEND_URL + "/register?reff=" + this.user.referral
                    this.user.password = ""
                    this.isLoading = false
                } catch (err) {
                    this.$toast.error(err.response.data.message)
                    this.$router.push("/dashboard")
                }
            },
            async updateUser() {
                try {
                    let response = await this.$store.dispatch('user_update', {
                        ...this.user,
                        timezone: parseInt(this.user.timezone),
                    })
                    this.$toast.success(response.data.message);
                    this.loadData()
                } catch (err) {
                    this.$toast.error(err.response.data.message);
                }
            },
            async resetApiKey() {
                try {
                    let response = await this.$store.dispatch('user_reset_api_key')
                    this.$toast.success(response.data.message);
                    this.loadData()
                } catch (err) {
                    this.$toast.error(err.response.data.message);
                }
            },
            async getOauthURL(){
                try {
                    let response = await this.$store.dispatch('user_get_oauth')
                    
                    var URL = response.data.data.url
                    window.location.href = URL
                } catch (err) {
                    this.$toast.error(err.response.data.message);
                }
            },
            copyAPIKey() {
                this.$toast.success("Copy API Key Berhasil");
                this.$refs["account_api_key"].focus();
                document.execCommand('copy');
            },
        },
    };
</script>